export default function Error ({ error, classes, toast }) {
  return error ? (
    <div className={`${classes} card border-2 border-red-400 rounded-md shadow-sm p-4 block`}>
      <h6 className='font-bold text-lg'>{error.status} - {error.status === 500 ? 'Server Error' : 'Bad Request'}</h6>
      <p className='text-red-600'>Details: {error.info || error.message || 'An unknown error occurred. Please try again.'}</p>
    </div>
  ) : null
}
